import getMailboxJunkEmailConfiguration from '../services/getMailboxJunkEmailConfiguration';
import setMailboxJunkEmailConfiguration from '../services/setMailboxJunkEmailConfiguration';
import { orchestrator } from 'satcheljs';
import addDomainsToBlockedList from '../actions/actionCreators/addDomainsToBlockedList';

/**
 * Fetches the junkEmailConfiguration, adds the mailbox to the end of trustedSendersAndDomains, and updates
 * the userConfiguration option locally and on the server
 */
orchestrator(addDomainsToBlockedList, async actionMessage => {
    const mailboxJunkEmailConfiguration = await getMailboxJunkEmailConfiguration();
    // Add any new domains
    actionMessage.domains.forEach((domain: string) => {
        if (mailboxJunkEmailConfiguration.BlockedSendersAndDomains.indexOf(domain) === -1) {
            mailboxJunkEmailConfiguration.BlockedSendersAndDomains.push(domain);
        }
    });

    setMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration);
});
